const stateObj = {
  openImageFullScreen: 0,
  updatedProblems: false,
  closedProblems: false,
}

const getters = {
  isImageFullScreenOpen (state) {
    return state.openImageFullScreen
  },
  problemsHasBeenUpdated (state) {
    return state.updatedProblems
  },
  problemsHasBeenFinished (state) {
    return state.closedProblems
  },
}

const mutations = {
  imageFullScreenOpen (state) {
    state.openImageFullScreen = true
  },
  imageFullScreenClose (state) {
    state.openImageFullScreen = false
  },
  updateProblems (state, value) {
    state.updatedProblems = value
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
}
